import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IInsepction } from "../../domain/IInspection";
import { resourcesServices } from "../../services/resource.service";
import { IPopoverState } from "Dashboard/scenes/Carnets/domain/IPopoverState";
import { IUpdateInspection } from "../../domain/IUpdateInspection";

export const getInspections = createAsyncThunk(
  "Resources/getInspections",
  async (resourceId: number) => {
    //thunkApi.dispatch(setLoading(true));
    try {
      return await resourcesServices.getInspections(resourceId);
    } catch (err) {
      setError(err);
    }
  }
);

export const updateInspection = createAsyncThunk(
  "ConcreteBase/updateInspection",
  async (data: IUpdateInspection, { rejectWithValue }) => {
    try {
      return await resourcesServices.updateInspection(data);
    } catch (err: any) {
      return rejectWithValue(err.response.status);
    }
  }
);
interface registrationAndTachographState {
  loading: boolean;
  registrationTachographPopover: IPopoverState;
  inspections: IInsepction[];
  error: any;
}

const initialState: registrationAndTachographState = {
  loading: false,
  registrationTachographPopover: { isOpen: false },
  inspections: [],
  error: null,
};

export const registrationAndTachographSlice = createSlice({
  name: "resources-registrationAndTachograph",
  initialState: initialState,
  reducers: {
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
    setRegistrationTachographPopoverState: (
      state,
      action: PayloadAction<IPopoverState>
    ) => {
      state.registrationTachographPopover = action.payload;
    },
    updateInspectionTemporarily: (state, action: PayloadAction<IUpdateInspection>) => {
      for (let inspectionIndex = 0; inspectionIndex < state.inspections.length; inspectionIndex++) {
        if (state.inspections[inspectionIndex].inspectionId === action.payload.inspectionId) {
          if (action.payload.note !== undefined) {
            state.inspections[inspectionIndex].note = action.payload.note;
          }
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInspections.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInspections.fulfilled, (state, action) => {
      state.loading = false;
      state.inspections = action.payload ? action.payload : [];
    });
    builder.addCase(getInspections.rejected, (state, action) => {
      state.loading = true;
      state.error = action.error;
    });
    builder.addCase(updateInspection.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateInspection.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.inspections = state.inspections.map(oldInspection => {
          if (oldInspection.inspectionId === action.payload.inspectionId) {
            return action.payload;
          } else {
            return oldInspection;
          }
        });
      }
    });
    builder.addCase(updateInspection.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const {
  setRegistrationTachographPopoverState,
  updateInspectionTemporarily,
  setError } =
  registrationAndTachographSlice.actions;

export const selectState = (state: RootState) =>
  state.resources.registrationAndTachograph;
export default registrationAndTachographSlice.reducer;
